import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { TherapiesPanel } from "@/components/app/therapy/therapies-panel";
import { orpc } from "@/lib/orpc";
import { useCan } from "@/lib/policy";

export const Route = createFileRoute("/_authenticated/_care/residents/$residentId/therapies")({
  component: ResidentTherapiesTab,
});

function ResidentTherapiesTab() {
  const { residentId } = Route.useParams();
  const { data: resident } = useSuspenseQuery(
    orpc.care.residents.get.queryOptions({ input: { residentId } }),
  );
  const canChart = useCan("therapy:chart", resident.facilityId);
  const canManage = useCan("therapy:manage", resident.facilityId);
  const canManagePackets = useCan("admission:manage", resident.facilityId);

  return (
    <TherapiesPanel
      residentId={residentId}
      facilityId={resident.facilityId}
      timezone={resident.facilityTimezone}
      canChart={canChart}
      canManage={canManage}
      canManagePackets={canManagePackets}
    />
  );
}
